import {
  httpsCallable,
  type Functions,
  type HttpsCallable,
  type HttpsCallableOptions,
} from "firebase/functions";
import { endpointTargets, type EndpointAction } from "@um/contracts";
import { omitUndefinedFields } from "./contentClient";

/** Keep each domain's payload/stream contract while using its canonical deployment. */
export function createEndpointCall<
  Input = unknown,
  Output = unknown,
  Chunk = unknown,
>(
  functions: Functions,
  action: EndpointAction,
  options?: HttpsCallableOptions
): HttpsCallable<Input, Output, Chunk> {
  const call = httpsCallable<
    { action: EndpointAction; request: Input },
    Output,
    Chunk
  >(functions, endpointTargets[action], options);
  const envelope = (request: Input) => ({
    action,
    request: omitUndefinedFields(request),
  });
  return Object.assign(
    (request?: Input | null) => call(envelope(request as Input)),
    {
      stream: (
        request?: Input | null,
        options?: Parameters<typeof call.stream>[1]
      ) => call.stream(envelope(request as Input), options),
    }
  );
}
